/* eslint-disable */

export enum Trigger {
  DO_NOT_USE_TRIGGER = "DO_NOT_USE_TRIGGER",
  /** APP_LAUNCH - App opened, resumed, or became active */
  APP_LAUNCH = "APP_LAUNCH",
  /** PUSH_NOTIFICATION - A system push notification requires an updated SyncEntity */
  PUSH_NOTIFICATION = "PUSH_NOTIFICATION",
  /** IMMEDIATE_NEXT_CALL - A previous request has a next page and it is being requested immediately */
  IMMEDIATE_NEXT_CALL = "IMMEDIATE_NEXT_CALL",
  /**
   * DELAYED_NEXT_CALL - A previous request has a next page and it is being requested after some waiting period
   * Previously this was also used for polling-triggered requests
   */
  DELAYED_NEXT_CALL = "DELAYED_NEXT_CALL",
  /** SERVER_PUSH - Server Push is distinct from push notifications, it uses a persistent streaming connection */
  SERVER_PUSH = "SERVER_PUSH",
  /** POLLING - Scheduled polling checks that occur while the app is open */
  POLLING = "POLLING",
  /** USER_ACTION - A user action (e.g. view details, change tab) requires SyncEntity updates */
  USER_ACTION = "USER_ACTION",
  /** WIDGET - Use by system widgets (iOS & Android, not treehouse), likely while the app is in the background */
  WIDGET = "WIDGET",
}

export interface SyncEntitiesRequest {
  /**
   * The newest token of the range to sync. Use null to fetch a range that includes
   * the most recent sync entities.
   */
  newest_token?: string;
  /**
   * The oldest token of the range to sync. Use null to fetch a range that includes
   * sync entities going back to the beginning of time.
   */
  oldest_token?: string;
  /** Metadata that stored on the device to be sent to the server to sync entities. */
  all_known_ranges?: Uint8Array[];
  /**
   * Devices hold state to manage their sync tokens. If a device sets this to true, the server knows
   * this state won't be lost by an upgrade to the ranges protocol; the server can then upgrade.
   * If this is null the server interprets it as false.
   */
  is_protocol_change_safe?: boolean;
  /** The calls will be prioritized according to the given trigger of the SyncEntitiesRequest. */
  trigger?: Trigger;
}
